import styled from '@emotion/styled';
import { shouldForwardProps } from '../../helpers';
import { theme } from '../../design-system';
import { Flex, Icon } from '.';
import { arrowDown } from '../../icons';

const StyledSelect = () => {
  return {
    backgroundColor: '#fbfbfb',
    border: 0,
    fontSize: '0.875rem',
    appearance: 'none',
    '&:focus': { outline: 0 },
  };
};

const StyledWrapper = ({ ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);
  return {
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: '#fbfbfb',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.colors.primary}`,
    minHeight: '50px',
    padding: '10px',
    position: 'relative',
    '& > div': {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
    },
    ...customPropsObj,
  };
};

const StyledLabel = () => {
  return {
    fontSize: '0.75rem',
    color: theme.colors.primary,
    fontFamily: 'Plus Jakarta Sans',
    marginBottom: '0.25rem',
  };
};

const SelectElement = styled('select')(StyledSelect);
const Wrapper = styled(Flex)(StyledWrapper);
const Label = styled('label')(StyledLabel);

export const Select = ({ children, ...props }) => {
  return (
    <Wrapper {...props}>
      <Label htmlFor={props.name}>{props.label}</Label>
      <SelectElement name={props.name} id={props.id} value={props.value} onChange={props.onChange} disabled={props.disabled}>
        {children}
      </SelectElement>
      <Icon icon={arrowDown} />
    </Wrapper>
  );
};
